var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-dialog",
    {
      attrs: { "max-width": "700" },
      model: {
        value: _vm.dialog,
        callback: function ($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog",
      },
    },
    [
      _vm.dialog
        ? _c("time-sheet-class-diary", {
            attrs: { embedded: "", title: _vm.title },
            on: {
              close: function ($event) {
                _vm.dialog = false
              },
              "open-timesheet": function ($event) {
                _vm.dialog = false
                _vm.$emit("open-timesheet")
              },
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }